import { render, staticRenderFns } from "./legendStallRiskPoint.vue?vue&type=template&id=7d85b1a8&scoped=true"
import script from "./legendStallRiskPoint.vue?vue&type=script&lang=ts"
export * from "./legendStallRiskPoint.vue?vue&type=script&lang=ts"
import style0 from "./legendStallRiskPoint.vue?vue&type=style&index=0&id=7d85b1a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d85b1a8",
  null
  
)

export default component.exports